import { render, staticRenderFns } from "./SaiquList.vue?vue&type=template&id=a2a6c6a4&"
import script from "./SaiquList.vue?vue&type=script&lang=js&"
export * from "./SaiquList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports